import React from 'react';
import { motion } from 'framer-motion';
import farmer from "../assets/images/farmer.png";

export default function OurPromises() {
    return (
        <div>
            <section className='px-[8%] py-[6%] grid lg:grid-cols-12 gap-8'>
                <div className='lg:col-span-6 pt-4 px-12'>
                    {/* About Us Title Animation */}
                    <motion.p
                        className='flex color-[#002455] tracking-[0.3rem] uppercase text-[.7rem]'
                        initial={{ opacity: 0, x: -100 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        About Us<span className='text-[var(--second-primary-color)] text-3xl leading-[.5] pl-3'>&#8594;</span>
                    </motion.p>

                    {/* Our Promise Title Animation */}
                    <motion.h3
                        className='md:pt-20 pt-10 text-[1.8rem] text-[#002455] font-[800] leading-[1.3]'
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        viewport={{ once: false }}
                        transition={{ delay: 0.3, duration: 0.8 }}
                    >
                        Our Promise
                    </motion.h3>

                    {/* Text Content Animation */}
                    <motion.div
                        className='text-[1rem] text-[#555D68] py-12 pr-8'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.6, duration: 0.8 }}
                    >
                        <p>We promise to provide the fastest, simplest, and most dependable money transfer experience. Our easy-to-use platform, competitive rates, and 24/7 customer support ensure your hard-earned money reaches family and friends abroad in seconds.</p>
                        <p className='pt-4'>The digital revolution is here, and Fastest is at the center, supporting entrepreneurs and businesses propelling the growth of the global internet economy.</p>
                    </motion.div>
                </div>

                <div className='lg:col-span-6'>
                    {/* Image Animation */}
                    <motion.img
                        src={farmer}
                        alt="a farmer"
                        className="w-full max-w-[80%] mx-auto"
                        initial={{ opacity: 0, y: 100 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: false }}
                        transition={{ delay: 0.8, duration: 0.8 }}
                    />

                </div>
            </section>

            <section className='px-[12%] py-[6%] grid lg:grid-cols-12 gap-8'>
                <div className='lg:col-span-6'>
                    {/* Promise Title Animation */}
                    <motion.h3
                        className='md:pt-10 pt-5 text-[1.2rem] md:text-[1.5rem] text-[#002455] font-[800] leading-[1.3]'
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: false }}
                        transition={{ delay: 0.3, duration: 0.8 }}
                    >
                        We’ll Help You Make <br /> Your Money Go Further, <br /> <span className='text-[var(--second-primary-color)]'>So You Can Too.</span>
                    </motion.h3>
                </div>

                <div className='lg:col-span-6 pt-4 '>
                    {/* About Us Text Animation */}
                    <motion.p
                        className='flex color-[#002455] tracking-[0.3rem] uppercase text-[.7rem] md:text-[.8rem]'
                        initial={{ opacity: 0, x: -100 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.6, duration: 0.8 }}
                    >
                        About Us<span className='text-[var(--second-primary-color)] text-3xl leading-[.5] pl-3'>&#8594;</span>
                    </motion.p>

                    {/* Promise Details Animation */}
                    <motion.div
                        className='flex gap-6 text-[1rem] text-[#555D68] py-12 '
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        viewport={{ once: false }}
                        transition={{ delay: 0.8, duration: 0.8 }}
                    >
                        <p>We serve both individuals and businesses seeking a better solution for sending and receiving funds globally.</p>
                        <p className=''>Whether you need to pay international bills, receive payments from overseas clients, or send money to loved ones - Fastest meets your needs.</p>
                    </motion.div>
                </div>
            </section>
        </div>
    );
}
